import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MyShopService } from '@my-shop/feature';
import { ProductGridItem } from '@product/const';
import { SdModalService, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { ProductAvailabilityComponent } from '../product-availability';

@Component({
  selector: 'sd-product-list-availability',
  templateUrl: './product-list-availability.component.html',
  styleUrls: ['./product-list-availability.component.scss'],
  imports: [AsyncPipe, SdvorIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdProductListAvailabilityComponent {
  readonly product = input.required<ProductGridItem>();

  readonly myShopService = inject(MyShopService);
  private readonly deviceService = inject(DeviceService);
  private readonly modalService = inject(SdModalService);

  readonly isDesktopLgUp = toSignal(this.deviceService.isDesktopLgUp$, { initialValue: false });

  openShopsModal(): void {
    const ignoreOutsideClick = !this.isDesktopLgUp();

    const modal = this.modalService.open(ProductAvailabilityComponent, {
      ignoreOutsideClick,
      modalType: { xxs: 'fullscreen', lg: 'compact' },
      maxWidth: { lg: '1200px' },
    });

    modal.contentRef.setInput('product', this.product());
  }
}
